// Tooltip.tsx
import React, { ReactNode } from 'react';
import './Tooltip.css';

interface TooltipProps {
  position: 'top' | 'right' | 'bottom' | 'left' | 'auto'; // Defines the allowed positions for the tooltip
  children: ReactNode; // Allows any valid React node as children
  visible: boolean; // Defines if the tooltip is visible or not
  customClass?: string; // Optional custom class for styling
  allowWrap?: boolean; // Optional height for the tooltip
}

export const Tooltip: React.FC<TooltipProps> = ({
  position,
  children,
  visible,
  customClass,
  allowWrap,
}) => {
  return (
    <div
      className={`tooltip bs-tooltip-${position} ${visible ? 'show' : ''} ${customClass ? customClass : ''}`}
      role="tooltip"
    >
      <div className={`tooltip-inner ${allowWrap ? 'wraps' : ''}`}>
        {children}
      </div>
    </div>
  );
};
